// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__16yU-","colCheckbox":"styles_colCheckbox__1-ukq"};